import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rut',
  standalone: true
})

export class RutPipe implements PipeTransform {
  transform(value: string, type: string): string {
    if (type === 'PASAPORTE') {
      return value;
    }

    const rutClean = value.replace(/[^0-9kK]/g, '');

    const rut = rutClean.slice(0, -1);
    const dv = rutClean.slice(-1);

    let rutFormatted: string[] = [];
    for (let i = rut.length; i > 0; i--) {
        rutFormatted.push(rut[i - 1]);
        if (i % 3 === 0) {
            rutFormatted.push('.');
        }
    }
    return `${rutFormatted.reverse().join('')}-${dv}`;
  }
}
